export default __webpack_public_path__ + "static/media/Positive.ad89552a.svg";